// extracted by mini-css-extract-plugin
export default {"bestelling":"ToonBestelling_bestelling__2gHBA"};